module.exports = __webpack_public_path__ + "static/media/logout-icon.59995cc9.svg";